import { Box, ButtonBase } from '@mui/material';
import React from 'react';
export const ContentBase = (props) => {
    const sx = {
        overflow: 'hidden',
        px: 2,
        py: props.hasIcons ? 1 : 0,
        display: 'grid',
        gap: 1,
        gridTemplateRows: !props.hasBadge ? 'auto' : 'auto 1fr auto',
        justifyContent: 'start',
    };
    return props.onClick ? (React.createElement(ButtonBase, { sx: sx, onClick: props.onClick, "aria-label": props.ariaLabel, focusRipple: true, "data-test": 'content' }, props.children)) : (React.createElement(Box, { sx: sx, "data-test": 'content' }, props.children));
};
